
import { core } from '@tock/coretypes';

export default ({
  location,
  includeBreaks,
}: {
  location: core.ILocation;
  includeBreaks?: boolean;
}) => {
  const cityStateZip = [location.city ? location.city + ',' : '', location.state, location.zipCode]
    .join(' ')
    .trim();
  return (
    <span>
      {location.name && (
        <span>
          {location.name}
          {includeBreaks ? <br /> : <span>, </span>}
        </span>
      )}
      {location.address && (
        <span>
          {location.address}
          {includeBreaks ? <br /> : <span>, </span>}
        </span>
      )}
      {location.address2 && (
        <span>
          {location.address2}
          {includeBreaks ? <br /> : <span>, </span>}
        </span>
      )}
      {cityStateZip && <span>{cityStateZip}</span>}
    </span>
  );
};
